import { State, Action, StateContext, Selector, Store, Select } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { Injectable } from '@angular/core';
import * as CustomerActions from './customer.action';
import { CustomerService } from './customer.service';
import * as CustomerModels from '../../models/customer/customer';
import { BannerService } from '../../shared/services/banner.service';
import { HelperService } from '../../../../src/app/services/helper/helper.service';
import * as Models from "../../models/commonModels";
import { saveAs } from "file-saver";
import { CustomerDictionarySearchModel } from '../../models/customer/customerSearch';

export interface CustomerStateModel {
  CustomerDictionary: CustomerModels.CustomerDictionaryListModel;
  CustomerDisactiveDictionary: CustomerModels.CustomerDictionaryListModel;
  CustomersUserList: CustomerModels.CustomersUserListModel;
  SubcompanyDictionary: CustomerModels.CustomerDictionaryListModel;
  Remove: Models.ResponseBase;
  ContractStatus: boolean;
  ParentChildList: CustomerModels.CustomerListModel;
  List: CustomerModels.CustomerListModel;
  Search: CustomerModels.CustomerSearchModel;
  SelectedCustomers: CustomerModels.CustomerPreviewModel[];
  Customer: Models.Response<CustomerModels.CustomerModel>;
  Garages: Models.Response<CustomerModels.CustomerGarageModel[]>;
  LinkGarage: Models.Response<CustomerModels.CustomerGarageModel>;
  LinkAllGarage: Models.Response<CustomerModels.CustomerGarageModel[]>;
  Report: Models.ReportProcessing;
  ServiceList: Models.Response<CustomerModels.CustomerServiceModel[]>;
  APICustomerServiceRights: Models.Response<CustomerModels.APICustomerServiceRightsModel[]>
  APICustomerServiceRight: Models.Response<CustomerModels.APICustomerServiceRightsModel>
}

@State<CustomerStateModel>({
  name: 'customerState',
  defaults: {
    CustomerDictionary: null,
    CustomerDisactiveDictionary: null,
    CustomersUserList: null,
    SubcompanyDictionary: null,
    ContractStatus: null,
    ParentChildList: null,
    Remove: null,
    List: null,
    Search: null,
    SelectedCustomers: null,
    Customer: null,
    Garages: null,
    LinkGarage: null,
    LinkAllGarage: null,
    Report: null,
    ServiceList: null,
    APICustomerServiceRights: null,
    APICustomerServiceRight: null
  }
})

@Injectable()

export class CustomerState {

  constructor(
    private helperService: HelperService,
    private customerService: CustomerService,
    private bannerService: BannerService
  ) { }

  @Selector()
  static ContractStatus(state: CustomerStateModel) {
    return state.ContractStatus;
  }


  @Selector()
  static CustomerDictionary(state: CustomerStateModel) {
    return state.CustomerDictionary;
  }

  @Selector()
  static SubcompanyDictionary(state: CustomerStateModel) {
    return state.SubcompanyDictionary;
  }

  @Selector()
  static CustomersUserList(state: CustomerStateModel) {
    return state.CustomersUserList;
  }

  @Selector()
  static ParentChildList(state: CustomerStateModel) {
    return state.ParentChildList;
  }

  @Selector()
  static List(state: CustomerStateModel) {
    return state.List;
  }

  @Selector()
  static Search(state: CustomerStateModel) {
    return state.Search;
  }

  @Selector()
  static CustomerDisactiveDictionary(state: CustomerStateModel) {
    return state.CustomerDisactiveDictionary;
  }

  @Selector()
  static SlectedCustomers(state: CustomerStateModel) {
    if (state.SelectedCustomers != null) return state.SelectedCustomers.slice();  /// TODO: after update Angular to 10 use ES6 syntax [...state.SelectedCustomers]
    else return [];
  }

  @Selector()
  static Customer(state: CustomerStateModel) {
    return state.Customer;
  }

  @Selector()
  static Garages(state: CustomerStateModel) {
    return state.Garages;
  }

  @Selector()
  static LinkGarage(state: CustomerStateModel) {
    return state.LinkGarage;
  }

  @Selector()
  static LinkAllGarage(state: CustomerStateModel) {
    return state.LinkAllGarage;
  }

  @Selector()
  static Remove(state: CustomerStateModel) {
    return state.Remove;
  }

  @Selector()
  static ServiceList(state: CustomerStateModel) {
    return state.ServiceList;
  }

  @Selector()
  static APICustomerServiceRights(state: CustomerStateModel) {
    return state.APICustomerServiceRights;
  }

  @Selector()
  static APICustomerServiceRight(state: CustomerStateModel) {
    return state.APICustomerServiceRight;
  }

  PatchReportContext(Name: string, IsProcessing: boolean, Context: StateContext<CustomerStateModel>) {
    if (IsProcessing) {
      Context.setState(
        patch({
          Report: Models.ReportProcessing.Start(Name),
        })
      );
    }
    else {
      Context.setState(
        patch({
          Report: Models.ReportProcessing.End(Name),
        })
      );
    }
  }

  @Action(CustomerActions.GetCustomerDictionary)
  getCustomerDictionary(
    context: StateContext<CustomerStateModel>,
    action: CustomerActions.GetCustomerDictionary
  ) {

    const errorMessage = 'Błąd pobierania listy klientów.';

    context.setState(
      patch({
        CustomerDictionary: null
      })
    );
    let search: CustomerDictionarySearchModel = new CustomerDictionarySearchModel();
    search.OnlyMy = action.OnlyMy;
    search.ShowExternalCustomers = action.ShowExternalCustomers;
    search.OnlyActive = action.OnlyActive;

    this.customerService.getSearchDictionary(search).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            CustomerDictionary: ret
          })
        );
      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {

        this.helperService.SaveException('CustomerActions.GetCustomerDictionary', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(CustomerActions.GetCustomerAvailableForServiceDictionary)
  GetCustomerAvailableForServiceDictionary(
    context: StateContext<CustomerStateModel>,
    action: CustomerActions.GetCustomerAvailableForServiceDictionary
  ) {

    const errorMessage = 'Błąd pobierania listy klientów.';

    context.setState(
      patch({
        CustomerDictionary: null
      })
    );

    let search: CustomerDictionarySearchModel = new CustomerDictionarySearchModel();
    search.OnlyActive = action.OnlyActive;
    search.IsNewCarAvailableByGarage = true;

    this.customerService.getSearchDictionary(search).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            CustomerDictionary: ret
          })
        );
      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {

        this.helperService.SaveException('CustomerActions.GetCustomerDictionary', error);

        this.bannerService.error(errorMessage);
      });
  }


  @Action(CustomerActions.GetDisactiveCustomerDictionary)
  getDisactiveCustomerDictionary(
    context: StateContext<CustomerStateModel>,
  ) {

    const errorMessage = 'Błąd pobierania listy klientów.';

    context.setState(
      patch({
        CustomerDisactiveDictionary: null
      })
    );

    this.customerService.getDisactive().subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            CustomerDisactiveDictionary: ret
          })
        );
      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {

        this.helperService.SaveException('CustomerActions.GetDisactiveCustomerDictionary', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(CustomerActions.GetCustomersUserList)
  getCustomersUserList(
    context: StateContext<CustomerStateModel>,
    action: CustomerActions.GetCustomersUserList
  ) {
    context.getState();

    const errorMessage = 'Błąd pobierania listy użytkowników klienta.';

    context.setState(
      patch({
        CustomerDisactiveDictionary: null
      })
    );

    this.customerService.getUsers(action.CustomerId).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            CustomersUserList: ret
          })
        );
      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {

        this.helperService.SaveException('CustomerActions.GetCustomersUserList', error);

        this.bannerService.error(errorMessage);
      });
  }


  @Action(CustomerActions.GetSubcompanies)
  getSubcompanies(
    context: StateContext<CustomerStateModel>,
  ) {

    const errorMessage = 'Błąd pobierania listy firm partnerskich.';

    context.setState(
      patch({
        SubcompanyDictionary: null
      })
    );

    this.customerService.getSubcompanies().subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            SubcompanyDictionary: ret
          })
        );
      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {

        this.helperService.SaveException('CustomerActions.GetSubcompanies', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(CustomerActions.GetContractStatus)
  getContractStatus(
    context: StateContext<CustomerStateModel>,
  ) {
    function patchContext(l: boolean) {
      context.setState(
        patch({
          ContractStatus: l
        })
      );
    }
    const errorMessage = 'Błąd pobierania statusu kontraktu.';

    this.customerService.getContractStatus().subscribe((ret) => {
      patchContext(ret);
    },
      (error) => {
        this.helperService.SaveException('CustomerActions.GetContractStatus', error);
        this.bannerService.error(errorMessage);
      });
  }


  @Action(CustomerActions.GetParentChildList)
  getParentChildList(
    context: StateContext<CustomerStateModel>,
    action: CustomerActions.GetParentChildList
  ) {
    context.setState(
      patch({
        ParentChildList: null
      })
    );

    this.customerService.getParentChildList(action.Search).subscribe(
      (data) => {
        if (data.Success) {

          context.setState(
            patch({
              ParentChildList: data,
            })
          );
        }
      },
      (error) => {
        this.bannerService.error("Błąd pobierania listy serwisów.");
        this.helperService.SaveException("GetParentChildList", error);
      }
    );
  }

  @Action(CustomerActions.GetList)
  getList(
    context: StateContext<CustomerStateModel>,
    action: CustomerActions.GetList
  ) {
    context.setState(
      patch({
        List: null
      })
    );

    this.customerService.getList(action.Search).subscribe(
      (data) => {
        if (data.Success) {
          context.setState(
            patch({
              List: data,
            })
          );
        }
      },
      (error) => {
        this.bannerService.error("Błąd pobierania listy serwisów.");
        this.helperService.SaveException("CustomerActions.GetList", error);
      }
    );
  }

  @Action(CustomerActions.SetCustomerSearch)
  setGarageSearch(
    context: StateContext<CustomerStateModel>,
    action: CustomerActions.SetCustomerSearch
  ) {
    action.Search.CurrentPage = 1;

    context.setState(
      patch({
        Search: action.Search,
      })
    );

    this.helperService.consoleLog(action.Search);

    context.dispatch(new CustomerActions.GetParentChildList(action.Search));
  }

  @Action(CustomerActions.SetCustomerListPage)
  setGarageListPage(
    context: StateContext<CustomerStateModel>,
    action: CustomerActions.SetCustomerListPage
  ) {
    context.setState(
      patch({
        Search: action.Search,
      })
    );

    this.helperService.consoleLog(action.Search);
    context.dispatch(new CustomerActions.GetParentChildList(action.Search));
  }

  @Action(CustomerActions.ResetCustomerSearch)
  resetGarageSearch(context: StateContext<CustomerStateModel>) {
    const state = context.getState();

    const newSearch = new CustomerModels.CustomerSearchModel();

    context.setState(
      patch({
        Search: newSearch,
      })
    );

    context.dispatch(new CustomerActions.GetParentChildList(newSearch));
  }

  @Action(CustomerActions.SetSelectedCustomers)
  setSelectedCustomers(
    context: StateContext<CustomerStateModel>,
    action: CustomerActions.SetSelectedCustomers) {
    const state = context.getState();

    context.setState({
      ...state,
      SelectedCustomers: action.Customers
    });
  }

  @Action(CustomerActions.Set)
  set(
    context: StateContext<CustomerStateModel>,
    action: CustomerActions.Set
  ) {
    const errorMessage = "Błąd aktualizacji klienta.";

    this.customerService.set(action.Customers).subscribe(
      (ret) => {
        this.bannerService.success(
          `Klient został zaaktualizowany.`
        );
        context.setState(
          patch({
            Customer: ret
          })
        );
      },
      (error) => {
        this.helperService.SaveException(
          "CustomerActions.Set",
          error
        );

        context.setState(
          patch({
            Customer: null
          })
        );
        this.bannerService.error(errorMessage);
      }
    );
  }

  @Action(CustomerActions.Remove)
  remove(
    context: StateContext<CustomerStateModel>,
    action: CustomerActions.Remove
  ) {
    const errorMessage = "Błąd podczas usuwania klienta.";

    this.customerService.remove(action.Customers).subscribe(
      (ret) => {
        if (ret.Success == true) {
          this.bannerService.success(
            `Klient został usunięty.`
          );
        }
        context.setState(
          patch({
            Remove: ret
          })
        );
      },
      (error) => {
        this.helperService.SaveException(
          "CustomerActions.Remove",
          error
        );

        context.setState(
          patch({
            Remove: null
          })
        );
        this.bannerService.error(errorMessage);
      }
    );
  }

  @Action(CustomerActions.SetActive)
  setActive(
    context: StateContext<CustomerStateModel>,
    action: CustomerActions.SetActive
  ) {
    const errorMessage = "Błąd aktualizacji klienta.";

    this.customerService.setActive(action.Customers).subscribe(
      (ret) => {
        this.bannerService.success(
          `Klient został zaaktualizowany.`
        );
        context.setState(
          patch({
            Customer: ret
          })
        );
      },
      (error) => {
        this.helperService.SaveException(
          "CustomerActions.SetActive",
          error
        );

        context.setState(
          patch({
            Customer: null
          })
        );
        this.bannerService.error(errorMessage);
      }
    );
  }

  @Action(CustomerActions.Create)
  create(
    context: StateContext<CustomerStateModel>,
    action: CustomerActions.Create
  ) {
    const errorMessage = "Błąd tworzenia klienta.";

    this.customerService.create(action.Customers).subscribe(
      (ret) => {
        this.bannerService.success(
          `Klient został utworzony.`
        );
        context.setState(
          patch({
            Customer: ret
          })
        );
      },
      (error) => {
        this.helperService.SaveException(
          "CustomerActions.Create",
          error
        );

        context.setState(
          patch({
            Customer: null
          })
        );
        this.bannerService.error(errorMessage);
      }
    );
  }

  @Action(CustomerActions.Get)
  get(
    context: StateContext<CustomerStateModel>,
    action: CustomerActions.Get
  ) {
    const errorMessage = "Błąd pobierania danych klienta.";

    this.customerService.getCustomer(action.Customers).subscribe(
      (ret) => {
        context.setState(
          patch({
            Customer: ret
          })
        );
      },
      (error) => {
        this.helperService.SaveException(
          "CustomerActions.Get",
          error
        );

        context.setState(
          patch({
            Customer: null
          })
        );
        this.bannerService.error(errorMessage);
      }
    );
  }

  @Action(CustomerActions.GetGarages)
  getGarages(
    context: StateContext<CustomerStateModel>,
    action: CustomerActions.GetGarages
  ) {
    const errorMessage = "Błąd pobierania serwisów dla klienta.";

    this.customerService.getGarages(action.Customer).subscribe(
      (ret) => {
        context.setState(
          patch({
            Garages: ret
          })
        );
      },
      (error) => {
        this.helperService.SaveException(
          "CustomerActions.GetGarages",
          error
        );

        context.setState(
          patch({
            Garages: null
          })
        );
        this.bannerService.error(errorMessage);
      }
    );
  }

  @Action(CustomerActions.LinkGarage)
  linkGarage(
    context: StateContext<CustomerStateModel>,
    action: CustomerActions.LinkGarage
  ) {
    const errorMessage = "Błąd przydzielania serwisu.";

    this.customerService.linkGarage(action.Link).subscribe(
      (ret) => {
        if (ret.Item && ret.Item.IsLinked == true) {
          this.bannerService.success(
            `Serwis został przydzielony klientowi.`
          );
        } else if (ret.Item && ret.Item.IsLinked == false) {
          this.bannerService.success(
            `Serwis został usunięty.`
          );
        }
        context.setState(
          patch({
            LinkGarage: ret
          })
        );
      },
      (error) => {
        this.helperService.SaveException(
          "CustomerActions.LinkGarage",
          error
        );

        context.setState(
          patch({
            LinkGarage: null
          })
        );
        this.bannerService.error(errorMessage);
      }
    );
  }

  @Action(CustomerActions.LinkAllGarage)
  linkAllGarage(
    context: StateContext<CustomerStateModel>,
    action: CustomerActions.LinkAllGarage
  ) {
    const errorMessage = "Błąd przydzielania serwisu.";

    this.customerService.linkAllGarage(action.Link).subscribe(
      (ret) => {
        if (ret.Item && ret.Item.some(s => s.IsLinked == true)) {
          this.bannerService.success(
            `Wybrane serwisy zostały przydzielone klientowi.`
          );
        } else if (ret.Item && ret.Item.some(s => s.IsLinked == true)) {
          this.bannerService.success(
            `Wybrane serwisy zostały usunięte.`
          );
        }
        context.setState(
          patch({
            LinkAllGarage: ret
          })
        );
      },
      (error) => {
        this.helperService.SaveException(
          "CustomerActions.LinkAllGarage",
          error
        );

        context.setState(
          patch({
            LinkAllGarage: null
          })
        );
        this.bannerService.error(errorMessage);
      }
    );
  }

  @Action(CustomerActions.GetCustomerChildListExcel)
  getCustomerChildListExcelReport(
    context: StateContext<CustomerStateModel>,
    action: CustomerActions.GetCustomerChildListExcel
  ) {

    this.PatchReportContext(action.ReportName, true, context);

    const fileName = "Klienci";
    this.bannerService.info(
      `Rozpoczęto generowanie pliku raportu ${fileName}, proszę czekać ...`,
      "Export danych"
    );

    this.customerService.getCustomerChildListExcelReport(action.Search).subscribe(
      (res) => {
        const file = new File(
          [res],
          `${fileName}-${this.helperService.TimeStamp()}.xlsx`,
          {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          }
        );
        saveAs(file);

        this.PatchReportContext(action.ReportName, true, context);
      },
      (res) => {
        this.PatchReportContext(action.ReportName, true, context);

        this.bannerService.error(`Błąd pobierania raportu: ${fileName}`);
      },
      () => {
        this.PatchReportContext(action.ReportName, true, context);

        this.helperService.consoleLog(
          "@Action(CustomerActions.GetCustomerChildListExcel)"
        );
      }
    );
  }

  @Action(CustomerActions.GetService)
  getService(
    context: StateContext<CustomerStateModel>,
    action: CustomerActions.GetService
  ) {
    const errorMessage = "Błąd pobierania serwisów dla klienta.";

    this.customerService.getService(action.Customer).subscribe(
      (ret) => {
        context.setState(
          patch({
            ServiceList: ret
          })
        );
      },
      (error) => {
        this.helperService.SaveException(
          "CustomerActions.GetService",
          error
        );

        context.setState(
          patch({
            ServiceList: null
          })
        );
        this.bannerService.error(errorMessage);
      }
    );
  }

  @Action(CustomerActions.LinkService)
  linkService(
    context: StateContext<CustomerStateModel>,
    action: CustomerActions.LinkService
  ) {
    const errorMessage = "Błąd przydzielania serwisu.";

    context.setState(
      patch({
        ServiceList: null
      })
    );

    this.customerService.linkService(action.Link).subscribe(
      (ret) => {
        // if (ret.Item && ret.Item.IsLinked == true) {
        //   this.bannerService.success(
        //     `Serwis został przydzielony klientowi.`
        //   );
        // } else if (ret.Item && ret.Item.IsLinked == false) {
        //   this.bannerService.success(
        //     `Serwis został usunięty.`
        //   );
        // }
        context.setState(
          patch({
            ServiceList: ret
          })
        );
      },
      (error) => {
        this.helperService.SaveException(
          "CustomerActions.LinkService",
          error
        );

        context.setState(
          patch({
            ServiceList: null
          })
        );
        this.bannerService.error(errorMessage);
      }
    );
  }

  @Action(CustomerActions.SetAPICustomerServiceRights)
  SetAPICustomerServiceRights(
    context: StateContext<CustomerStateModel>,
    action: CustomerActions.SetAPICustomerServiceRights
  ) {
    const errorMessage = "Błąd zapisu uprawnień do serwisów API.";

    this.customerService.setAPICustomerServiceRights(action.APICustomerServiceRight).subscribe(
      (ret) => {
        context.setState(
          patch({
            APICustomerServiceRight: ret
          })
        );
      },
      (error) => {
        this.helperService.SaveException(
          "CustomerActions.SetAPICustomerServiceRights",
          error
        );

        context.setState(
          patch({
            ServiceList: null
          })
        );
        this.bannerService.error(errorMessage);
      }
    );
  }

  @Action(CustomerActions.GetAPICustomerServiceRights)
  GetAPICustomerServiceRights(
    context: StateContext<CustomerStateModel>,
    action: CustomerActions.GetAPICustomerServiceRights
  ) {
    const errorMessage = "Błąd pobierania serwisów API.";

    context.setState(
      patch({
        ServiceList: null
      })
    );

    this.customerService.getAPICustomerServiceRights(action.Customer).subscribe(
      (ret) => {

        context.setState(
          patch({
            APICustomerServiceRights: ret
          })
        );
      },
      (error) => {
        this.helperService.SaveException(
          "CustomerActions.GetAPICustomerServiceRights",
          error
        );

        context.setState(
          patch({
            ServiceList: null
          })
        );
        this.bannerService.error(errorMessage);
      }
    );
  }
}

